(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  
  
  
  
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;

            const recommendations = html.querySelector('[grid-recommendation]');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.querySelector('[grid-recommendation]').innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solbright-all-purpose-polish"] && !Shopify.designMode) return;
  try {
    

(function(){

  document
    .querySelectorAll('[data-sb-section]')
    .forEach(function(root){


      /* PRODUCT GALLERY */

      var galleryTrack =
        root.querySelector('[data-sb-gallery-track]');


      var thumbs =
        root.querySelectorAll('[data-sb-thumb]');


      function setActiveThumb(index){

        thumbs.forEach(function(item, i){

          item.classList.toggle(
            'is-active',
            i === index
          );

        });

      }


      if(galleryTrack){

        var galleryScrollTimeout;

        galleryTrack.addEventListener(
          'scroll',
          function(){

            clearTimeout(galleryScrollTimeout);

            galleryScrollTimeout =
              setTimeout(
                function(){

                  var index =
                    Math.round(
                      galleryTrack.scrollLeft /
                      galleryTrack.clientWidth
                    );

                  setActiveThumb(index);

                },
                100
              );

          },
          { passive: true }
        );

      }


      thumbs.forEach(function(thumb, index){

        thumb.addEventListener(
          'click',
          function(){

            if(galleryTrack){

              galleryTrack.scrollTo({
                left: index * galleryTrack.clientWidth,
                behavior: 'smooth'
              });

            }


            setActiveThumb(index);

          }
        );

      });



      /* VARIANTS */

      function getSelected(){

        return (
          root.querySelector(
            '[data-sb-tier]:checked'
          )
          ||
          root.querySelector(
            '[data-sb-tier]'
          )
        );

      }


      function refresh(){

        var selected =
          getSelected();


        if(!selected){
          return;
        }


        var price =
          selected.getAttribute(
            'data-price'
          );


        var title =
          selected.getAttribute(
            'data-title'
          );


        var priceRegular =
          selected.getAttribute(
            'data-price-regular'
          );


        var priceOffer =
          selected.getAttribute(
            'data-price-offer'
          );


        root
          .querySelectorAll('[data-sb-price]')
          .forEach(function(el){

            el.textContent = price;

          });


        root
          .querySelectorAll(
            '[data-sb-sticky-variant]'
          )
          .forEach(function(el){

            el.textContent = title;

          });


        /* Keep the offer card's Regular Total / Offer Price numbers
           in sync with whichever size is actually selected — sourced
           entirely from the real Shopify variant price and the real
           Shopify discount amount already carried on the radio
           (data-price-regular / data-price-offer), never recomputed
           or hardcoded in JS. */

        if(priceRegular){

          root
            .querySelectorAll('[data-sb-gift-regular]')
            .forEach(function(el){

              el.textContent = priceRegular;

            });

        }


        if(priceOffer){

          root
            .querySelectorAll('[data-sb-gift-offer-price]')
            .forEach(function(el){

              el.textContent = priceOffer;

            });

        }


        root
          .querySelectorAll('[data-sb-gift-copy-for]')
          .forEach(function(el){

            el.hidden =
              el.getAttribute('data-sb-gift-copy-for') !== title;

          });


        /* The offer only applies to 1 Liter / 5 Liter — hide the whole
           card (not just disable it) whenever a non-qualifying size
           is selected, uncheck it if it was already checked, and
           restore it when the customer switches back to a size the
           offer does apply to. */

        var giftToggle =
          root.querySelector('[data-sb-gift-toggle]');

        var offerCard =
          root.querySelector('[data-sb-offer]');

        if(giftToggle){

          var eligible =
            selected.getAttribute('data-sb-gift-eligible') !== 'false';

          if(eligible){
            giftToggle.disabled = false;
          } else {
            giftToggle.checked = false;
            giftToggle.disabled = true;
          }

          if(offerCard){
            offerCard.hidden = !eligible;
          }

        }


        /* Switch the gallery to whichever real Shopify image is
           assigned to the selected variant (Admin > Variant >
           Image), if one is assigned. Reuses the same scroll +
           active-thumb mechanism as the manual gallery controls.
           Falls back to doing nothing when a variant has no
           dedicated image, so products without per-variant images
           are unaffected. */

        var variantImageId =
          selected.getAttribute('data-sb-variant-image-id');

        if(variantImageId && galleryTrack){

          var gallerySlides =
            root.querySelectorAll('[data-sb-gallery-slide]');

          for(var sIndex = 0; sIndex < gallerySlides.length; sIndex++){

            if(
              gallerySlides[sIndex].getAttribute('data-media-id') ===
              variantImageId
            ){

              galleryTrack.scrollTo({
                left: sIndex * galleryTrack.clientWidth,
                behavior: 'smooth'
              });

              setActiveThumb(sIndex);

              break;

            }

          }

        }


        /* Add to Cart / Buy Now / sticky bar / final CTA — disable
           and relabel "Sold Out" based on the SPECIFIC selected
           variant's own availability, not just whether the product
           has any available variant at all. Remembers each button's
           original label the first time it's overridden, so
           switching back to an in-stock size restores the real
           configured label instead of a hardcoded string. */

        var variantAvailable =
          selected.getAttribute('data-sb-available') !== 'false';

        root
          .querySelectorAll('[data-sb-add]')
          .forEach(function(addButton){

            addButton.disabled = !variantAvailable;

            var addLabel =
              addButton.querySelector('[data-sb-add-label]');

            if(!addLabel){
              return;
            }

            if(!variantAvailable){

              if(!addButton.getAttribute('data-sb-label-default')){
                addButton.setAttribute(
                  'data-sb-label-default',
                  addLabel.textContent
                );
              }

              addLabel.textContent = 'Sold Out';

            } else {

              var defaultLabel =
                addButton.getAttribute('data-sb-label-default');

              if(defaultLabel){
                addLabel.textContent = defaultLabel;
              }

            }

          });

      }


      root
        .querySelectorAll('[data-sb-tier]')
        .forEach(function(tier){

          tier.addEventListener(
            'change',
            refresh
          );

        });



      /* ADD TO CART */

      function addToCart(button){

        var selected =
          getSelected();


        if(!selected){
          return;
        }


        var id =
          parseInt(
            selected.getAttribute(
              'data-variant-id'
            ),
            10
          );


        if(!id){
          return;
        }


        /* Quantity comes from the deliberate free-gift opt-in
           checkbox, combined with however many units the CURRENTLY
           SELECTED size's own offer adds (2 for 1 Liter, 2 for 5
           Liter — see data-sb-gift-qty on each size radio). Never
           checked by default, so a plain Add to Cart always means
           quantity 1 unless the customer explicitly opted in. */

        var giftToggle =
          root.querySelector('[data-sb-gift-toggle]');

        var qty = 1;

        if(giftToggle && giftToggle.checked){

          qty =
            parseInt(
              selected.getAttribute('data-sb-gift-qty'),
              10
            ) || 1;

        }


        button.disabled = true;


        var label =
          button.querySelector(
            '[data-sb-add-label]'
          );


        var originalLabel =
          label ?
            label.textContent :
            null;


        if(label){
          label.textContent = 'Adding...';
        }


        fetch(
          '/cart/add.js',
          {
            method:'POST',

            headers:{
              'Content-Type':
                'application/json',

              'Accept':
                'application/json'
            },

            body:JSON.stringify({

              items:[
                {
                  id:id,
                  quantity:qty
                }
              ]

            })
          }
        )

        .then(function(response){

          if(!response.ok){
            throw new Error();
          }

          return response.json();

        })

        .then(function(){

          var redirectTo =
            button.getAttribute('data-sb-redirect') ||
            '/cart';

          window.location.href = redirectTo;

        })

        .catch(function(){

          button.disabled = false;


          if(label){
            label.textContent =
              originalLabel || 'Add to cart';
          }


          alert(
            'Sorry, we could not add this item to your cart. Please try again.'
          );

        });

      }


      root
        .querySelectorAll('[data-sb-add]')
        .forEach(function(button){

          button.addEventListener(
            'click',
            function(){

              addToCart(button);

            }
          );

        });



      /* STICKY */

      var sticky =
        root.querySelector(
          '[data-sb-sticky]'
        );


      var buybox =
        root.querySelector(
          '.sb-buybox'
        );


      var finalCta =
        root.querySelector(
          '.sb-final'
        );


      if(
        sticky
        &&
        buybox
        &&
        'IntersectionObserver' in window
      ){

        var buyboxVisible = true;
        var finalCtaVisible = false;


        function updateSticky(){

          sticky.hidden =
            buyboxVisible ||
            finalCtaVisible;

        }


        new IntersectionObserver(

          function(entries){

            entries.forEach(
              function(entry){

                buyboxVisible =
                  entry.isIntersecting;

                updateSticky();

              }
            );

          },

          {
            rootMargin:
              '0px 0px -65% 0px'
          }

        ).observe(buybox);


        /* Hide the sticky bar once the final CTA comes into view —
           it's redundant next to that block's own buy button, and this
           means we never need to reserve empty space at the bottom of
           the page for the fixed bar to avoid covering the footer. */
        if(finalCta){

          new IntersectionObserver(

            function(entries){

              entries.forEach(
                function(entry){

                  finalCtaVisible =
                    entry.isIntersecting;

                  updateSticky();

                }
              );

            },

            {
              rootMargin:
                '0px 0px -10% 0px'
            }

          ).observe(finalCta);

        }

      }


      refresh();


      /* COMPACT REVIEW CARD (above size picker) — real swipeable
         track (same scroll-snap technique as the product gallery
         above), auto-advances every 3s between "review" blocks,
         loops, pauses on hover/keyboard focus, and never
         auto-starts if the visitor prefers reduced motion
         (manual prev/next and touch-swipe still work either
         way). Scrolling the track by hand (touch swipe) keeps
         miniIndex in sync so auto-rotation resumes from the
         right slide. */

      var miniReview =
        root.querySelector('[data-sb-mini-review]');

      if(miniReview){

        var miniTrack =
          miniReview.querySelector('[data-sb-mini-review-track]');

        var miniSlides =
          miniReview.querySelectorAll('[data-sb-mini-review-slide]');

        var miniIndex = 0;
        var miniTimer = null;
        var miniScrollTimeout;

        var miniPrefersReducedMotion =
          window.matchMedia &&
          window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        function showMiniReview(index){

          miniIndex = index;

          miniTrack.scrollTo({
            left: index * miniTrack.clientWidth,
            behavior: 'smooth'
          });

        }

        function nextMiniReview(){
          showMiniReview((miniIndex + 1) % miniSlides.length);
        }

        function prevMiniReview(){
          showMiniReview(
            (miniIndex - 1 + miniSlides.length) % miniSlides.length
          );
        }

        function startMiniRotation(){

          if(miniSlides.length < 2 || miniPrefersReducedMotion){
            return;
          }

          stopMiniRotation();

          miniTimer = setInterval(nextMiniReview, 3000);

        }

        function stopMiniRotation(){

          if(miniTimer){
            clearInterval(miniTimer);
            miniTimer = null;
          }

        }

        if(miniTrack){

          miniTrack.addEventListener(
            'scroll',
            function(){

              clearTimeout(miniScrollTimeout);

              miniScrollTimeout = setTimeout(function(){

                miniIndex =
                  Math.round(
                    miniTrack.scrollLeft / miniTrack.clientWidth
                  );

              }, 100);

            },
            { passive: true }
          );

        }

        var miniPrevBtn =
          miniReview.querySelector('[data-sb-mini-review-prev]');

        var miniNextBtn =
          miniReview.querySelector('[data-sb-mini-review-next]');

        if(miniPrevBtn){
          miniPrevBtn.addEventListener('click', function(){
            prevMiniReview();
            startMiniRotation();
          });
        }

        if(miniNextBtn){
          miniNextBtn.addEventListener('click', function(){
            nextMiniReview();
            startMiniRotation();
          });
        }

        miniReview.addEventListener('mouseenter', stopMiniRotation);
        miniReview.addEventListener('mouseleave', startMiniRotation);
        miniReview.addEventListener('focusin', stopMiniRotation);
        miniReview.addEventListener('touchstart', stopMiniRotation, { passive: true });
        miniReview.addEventListener('touchend', startMiniRotation, { passive: true });

        miniReview.addEventListener('focusout', function(event){
          if(!miniReview.contains(event.relatedTarget)){
            startMiniRotation();
          }
        });

        startMiniRotation();

      }



      /* BUNDLE OFFER — synchronized 4-hour countdown.

         Refreshes on fixed Pakistan-time (UTC+5) boundaries
         (00:00 / 04:00 / 08:00 / 12:00 / 16:00 / 20:00), computed
         purely from the visitor's clock (Date.now()) — no
         localStorage, no per-visitor deadline, no server round
         trip. Because every visitor's browser resolves the same
         UTC instant to the same next boundary, the countdown is
         naturally identical for everyone without any syncing. */

      var offerTimer =
        root.querySelector('[data-sb-offer-timer]');

      if(offerTimer){

        var SB_PKT_OFFSET_MS = 5 * 60 * 60 * 1000;
        var SB_WINDOW_MS = 4 * 60 * 60 * 1000;

        function sbPad(value){
          return value < 10 ? '0' + value : String(value);
        }

        function renderOfferTimer(){

          var now = Date.now();
          var pktNow = now + SB_PKT_OFFSET_MS;

          var nextBoundaryPkt =
            Math.ceil(pktNow / SB_WINDOW_MS) * SB_WINDOW_MS;

          var nextBoundaryUtc =
            nextBoundaryPkt - SB_PKT_OFFSET_MS;

          var remainingMs =
            Math.max(0, nextBoundaryUtc - now);

          var totalSeconds =
            Math.floor(remainingMs / 1000);

          var hours =
            Math.floor(totalSeconds / 3600);

          var minutes =
            Math.floor((totalSeconds % 3600) / 60);

          var seconds =
            totalSeconds % 60;

          offerTimer.textContent =
            sbPad(hours) + ' : ' +
            sbPad(minutes) + ' : ' +
            sbPad(seconds);

        }

        renderOfferTimer();
        setInterval(renderOfferTimer, 1000);

      }


      /* BUNDLE OFFER — clickable "Offer ends in" shortcut.
         Adds 2 of the currently selected size, then takes the
         customer straight to the cart. The real Shopify discount
         applies automatically at checkout. */

      var offerCta =
        root.querySelector('[data-sb-offer-cta]');

      if(offerCta){

        var offerCtaBusy = false;

        offerCta.addEventListener(
          'click',
          function(){

            if(offerCtaBusy){
              return;
            }

            var selected =
              getSelected();

            if(!selected){
              return;
            }

            if(
              selected.getAttribute(
                'data-sb-gift-eligible'
              ) === 'false'
            ){
              return;
            }

            var id =
              parseInt(
                selected.getAttribute(
                  'data-variant-id'
                ),
                10
              );

            if(!id){
              return;
            }

            var ctaQty =
              parseInt(
                selected.getAttribute('data-sb-gift-qty'),
                10
              ) || 1;

            offerCtaBusy = true;
            offerCta.classList.add('is-loading');

            fetch(
              '/cart/add.js',
              {
                method:'POST',

                headers:{
                  'Content-Type':
                    'application/json',

                  'Accept':
                    'application/json'
                },

                body:JSON.stringify({

                  items:[
                    {
                      id:id,
                      quantity:ctaQty
                    }
                  ]

                })
              }
            )

            .then(function(response){

              if(!response.ok){
                throw new Error();
              }

              return response.json();

            })

            .then(function(){

              window.location.href = '/cart';

            })

            .catch(function(){

              offerCtaBusy = false;
              offerCta.classList.remove('is-loading');

              alert(
                'Sorry, we could not add this item to your cart. Please try again.'
              );

            });

          }
        );

      }

    });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solbright-ev-polish-black-control"] && !Shopify.designMode) return;
  try {
    

(function(){

  document
    .querySelectorAll('[data-sb-section]')
    .forEach(function(root){


      /* PRODUCT GALLERY */

      var galleryTrack =
        root.querySelector('[data-sb-gallery-track]');


      var thumbs =
        root.querySelectorAll('[data-sb-thumb]');


      function setActiveThumb(index){

        thumbs.forEach(function(item, i){

          item.classList.toggle(
            'is-active',
            i === index
          );

        });

      }


      if(galleryTrack){

        var galleryScrollTimeout;

        galleryTrack.addEventListener(
          'scroll',
          function(){

            clearTimeout(galleryScrollTimeout);

            galleryScrollTimeout =
              setTimeout(
                function(){

                  var index =
                    Math.round(
                      galleryTrack.scrollLeft /
                      galleryTrack.clientWidth
                    );

                  setActiveThumb(index);

                },
                100
              );

          },
          { passive: true }
        );

      }


      thumbs.forEach(function(thumb, index){

        thumb.addEventListener(
          'click',
          function(){

            if(galleryTrack){

              galleryTrack.scrollTo({
                left: index * galleryTrack.clientWidth,
                behavior: 'smooth'
              });

            }


            setActiveThumb(index);

          }
        );

      });



      /* VARIANTS */

      function getSelected(){

        return (
          root.querySelector(
            '[data-sb-tier]:checked'
          )
          ||
          root.querySelector(
            '[data-sb-tier]'
          )
        );

      }


      function refresh(){

        var selected =
          getSelected();


        if(!selected){
          return;
        }


        var price =
          selected.getAttribute(
            'data-price'
          );


        var title =
          selected.getAttribute(
            'data-title'
          );


        var priceRegular =
          selected.getAttribute(
            'data-price-regular'
          );


        var priceOffer =
          selected.getAttribute(
            'data-price-offer'
          );


        root
          .querySelectorAll('[data-sb-price]')
          .forEach(function(el){

            el.textContent = price;

          });


        root
          .querySelectorAll(
            '[data-sb-sticky-variant]'
          )
          .forEach(function(el){

            el.textContent = title;

          });


        /* Keep the offer card's Regular Total / Offer Price numbers
           in sync with whichever size is actually selected — sourced
           entirely from the real Shopify variant price and the real
           Shopify discount amount already carried on the radio
           (data-price-regular / data-price-offer), never recomputed
           or hardcoded in JS. */

        if(priceRegular){

          root
            .querySelectorAll('[data-sb-gift-regular]')
            .forEach(function(el){

              el.textContent = priceRegular;

            });

        }


        if(priceOffer){

          root
            .querySelectorAll('[data-sb-gift-offer-price]')
            .forEach(function(el){

              el.textContent = priceOffer;

            });

        }


        root
          .querySelectorAll('[data-sb-gift-copy-for]')
          .forEach(function(el){

            el.hidden =
              el.getAttribute('data-sb-gift-copy-for') !== title;

          });


        /* The offer only applies to 1 Liter / 5 Liter — hide the whole
           card (not just disable it) whenever a non-qualifying size
           is selected, uncheck it if it was already checked, and
           restore it when the customer switches back to a size the
           offer does apply to. */

        var giftToggle =
          root.querySelector('[data-sb-gift-toggle]');

        var offerCard =
          root.querySelector('[data-sb-offer]');

        if(giftToggle){

          var eligible =
            selected.getAttribute('data-sb-gift-eligible') !== 'false';

          if(eligible){
            giftToggle.disabled = false;
          } else {
            giftToggle.checked = false;
            giftToggle.disabled = true;
          }

          if(offerCard){
            offerCard.hidden = !eligible;
          }

        }


        /* Switch the gallery to whichever real Shopify image is
           assigned to the selected variant (Admin > Variant >
           Image), if one is assigned. Reuses the same scroll +
           active-thumb mechanism as the manual gallery controls.
           Falls back to doing nothing when a variant has no
           dedicated image, so products without per-variant images
           are unaffected. */

        var variantImageId =
          selected.getAttribute('data-sb-variant-image-id');

        if(variantImageId && galleryTrack){

          var gallerySlides =
            root.querySelectorAll('[data-sb-gallery-slide]');

          for(var sIndex = 0; sIndex < gallerySlides.length; sIndex++){

            if(
              gallerySlides[sIndex].getAttribute('data-media-id') ===
              variantImageId
            ){

              galleryTrack.scrollTo({
                left: sIndex * galleryTrack.clientWidth,
                behavior: 'smooth'
              });

              setActiveThumb(sIndex);

              break;

            }

          }

        }


        /* Add to Cart / Buy Now / sticky bar / final CTA — disable
           and relabel "Sold Out" based on the SPECIFIC selected
           variant's own availability, not just whether the product
           has any available variant at all. Remembers each button's
           original label the first time it's overridden, so
           switching back to an in-stock size restores the real
           configured label instead of a hardcoded string. */

        var variantAvailable =
          selected.getAttribute('data-sb-available') !== 'false';

        root
          .querySelectorAll('[data-sb-add]')
          .forEach(function(addButton){

            addButton.disabled = !variantAvailable;

            var addLabel =
              addButton.querySelector('[data-sb-add-label]');

            if(!addLabel){
              return;
            }

            if(!variantAvailable){

              if(!addButton.getAttribute('data-sb-label-default')){
                addButton.setAttribute(
                  'data-sb-label-default',
                  addLabel.textContent
                );
              }

              addLabel.textContent = 'Sold Out';

            } else {

              var defaultLabel =
                addButton.getAttribute('data-sb-label-default');

              if(defaultLabel){
                addLabel.textContent = defaultLabel;
              }

            }

          });

      }


      root
        .querySelectorAll('[data-sb-tier]')
        .forEach(function(tier){

          tier.addEventListener(
            'change',
            refresh
          );

        });



      /* ADD TO CART */

      function addToCart(button){

        var selected =
          getSelected();


        if(!selected){
          return;
        }


        var id =
          parseInt(
            selected.getAttribute(
              'data-variant-id'
            ),
            10
          );


        if(!id){
          return;
        }


        /* Quantity comes from the deliberate free-gift opt-in
           checkbox, combined with however many units the CURRENTLY
           SELECTED size's own offer adds (2 for 1 Liter, 2 for 5
           Liter — see data-sb-gift-qty on each size radio). Never
           checked by default, so a plain Add to Cart always means
           quantity 1 unless the customer explicitly opted in. */

        var giftToggle =
          root.querySelector('[data-sb-gift-toggle]');

        var qty = 1;

        if(giftToggle && giftToggle.checked){

          qty =
            parseInt(
              selected.getAttribute('data-sb-gift-qty'),
              10
            ) || 1;

        }


        button.disabled = true;


        var label =
          button.querySelector(
            '[data-sb-add-label]'
          );


        var originalLabel =
          label ?
            label.textContent :
            null;


        if(label){
          label.textContent = 'Adding...';
        }


        fetch(
          '/cart/add.js',
          {
            method:'POST',

            headers:{
              'Content-Type':
                'application/json',

              'Accept':
                'application/json'
            },

            body:JSON.stringify({

              items:[
                {
                  id:id,
                  quantity:qty
                }
              ]

            })
          }
        )

        .then(function(response){

          if(!response.ok){
            throw new Error();
          }

          return response.json();

        })

        .then(function(){

          var redirectTo =
            button.getAttribute('data-sb-redirect') ||
            '/cart';

          window.location.href = redirectTo;

        })

        .catch(function(){

          button.disabled = false;


          if(label){
            label.textContent =
              originalLabel || 'Add to cart';
          }


          alert(
            'Sorry, we could not add this item to your cart. Please try again.'
          );

        });

      }


      root
        .querySelectorAll('[data-sb-add]')
        .forEach(function(button){

          button.addEventListener(
            'click',
            function(){

              addToCart(button);

            }
          );

        });



      /* STICKY */

      var sticky =
        root.querySelector(
          '[data-sb-sticky]'
        );


      var buybox =
        root.querySelector(
          '.sb-buybox'
        );


      var finalCta =
        root.querySelector(
          '.sb-final'
        );


      if(
        sticky
        &&
        buybox
        &&
        'IntersectionObserver' in window
      ){

        var buyboxVisible = true;
        var finalCtaVisible = false;


        function updateSticky(){

          sticky.hidden =
            buyboxVisible ||
            finalCtaVisible;

        }


        new IntersectionObserver(

          function(entries){

            entries.forEach(
              function(entry){

                buyboxVisible =
                  entry.isIntersecting;

                updateSticky();

              }
            );

          },

          {
            rootMargin:
              '0px 0px -65% 0px'
          }

        ).observe(buybox);


        /* Hide the sticky bar once the final CTA comes into view —
           it's redundant next to that block's own buy button, and this
           means we never need to reserve empty space at the bottom of
           the page for the fixed bar to avoid covering the footer. */
        if(finalCta){

          new IntersectionObserver(

            function(entries){

              entries.forEach(
                function(entry){

                  finalCtaVisible =
                    entry.isIntersecting;

                  updateSticky();

                }
              );

            },

            {
              rootMargin:
                '0px 0px -10% 0px'
            }

          ).observe(finalCta);

        }

      }


      refresh();


      /* BUNDLE OFFER — synchronized 4-hour countdown.

         Refreshes on fixed Pakistan-time (UTC+5) boundaries
         (00:00 / 04:00 / 08:00 / 12:00 / 16:00 / 20:00), computed
         purely from the visitor's clock (Date.now()) — no
         localStorage, no per-visitor deadline, no server round
         trip. Because every visitor's browser resolves the same
         UTC instant to the same next boundary, the countdown is
         naturally identical for everyone without any syncing. */

      var offerTimer =
        root.querySelector('[data-sb-offer-timer]');

      if(offerTimer){

        var SB_PKT_OFFSET_MS = 5 * 60 * 60 * 1000;
        var SB_WINDOW_MS = 4 * 60 * 60 * 1000;

        function sbPad(value){
          return value < 10 ? '0' + value : String(value);
        }

        function renderOfferTimer(){

          var now = Date.now();
          var pktNow = now + SB_PKT_OFFSET_MS;

          var nextBoundaryPkt =
            Math.ceil(pktNow / SB_WINDOW_MS) * SB_WINDOW_MS;

          var nextBoundaryUtc =
            nextBoundaryPkt - SB_PKT_OFFSET_MS;

          var remainingMs =
            Math.max(0, nextBoundaryUtc - now);

          var totalSeconds =
            Math.floor(remainingMs / 1000);

          var hours =
            Math.floor(totalSeconds / 3600);

          var minutes =
            Math.floor((totalSeconds % 3600) / 60);

          var seconds =
            totalSeconds % 60;

          offerTimer.textContent =
            sbPad(hours) + ' : ' +
            sbPad(minutes) + ' : ' +
            sbPad(seconds);

        }

        renderOfferTimer();
        setInterval(renderOfferTimer, 1000);

      }


      /* BUNDLE OFFER — clickable "Offer ends in" shortcut.
         Adds 2 of the currently selected size, then takes the
         customer straight to the cart. The real Shopify discount
         applies automatically at checkout. */

      var offerCta =
        root.querySelector('[data-sb-offer-cta]');

      if(offerCta){

        var offerCtaBusy = false;

        offerCta.addEventListener(
          'click',
          function(){

            if(offerCtaBusy){
              return;
            }

            var selected =
              getSelected();

            if(!selected){
              return;
            }

            if(
              selected.getAttribute(
                'data-sb-gift-eligible'
              ) === 'false'
            ){
              return;
            }

            var id =
              parseInt(
                selected.getAttribute(
                  'data-variant-id'
                ),
                10
              );

            if(!id){
              return;
            }

            var ctaQty =
              parseInt(
                selected.getAttribute('data-sb-gift-qty'),
                10
              ) || 1;

            offerCtaBusy = true;
            offerCta.classList.add('is-loading');

            fetch(
              '/cart/add.js',
              {
                method:'POST',

                headers:{
                  'Content-Type':
                    'application/json',

                  'Accept':
                    'application/json'
                },

                body:JSON.stringify({

                  items:[
                    {
                      id:id,
                      quantity:ctaQty
                    }
                  ]

                })
              }
            )

            .then(function(response){

              if(!response.ok){
                throw new Error();
              }

              return response.json();

            })

            .then(function(){

              window.location.href = '/cart';

            })

            .catch(function(){

              offerCtaBusy = false;
              offerCta.classList.remove('is-loading');

              alert(
                'Sorry, we could not add this item to your cart. Please try again.'
              );

            });

          }
        );

      }

    });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solbright-ev-polish-black"] && !Shopify.designMode) return;
  try {
    

(function(){

  document
    .querySelectorAll('[data-sb-section]')
    .forEach(function(root){


      /* PRODUCT GALLERY */

      var galleryTrack =
        root.querySelector('[data-sb-gallery-track]');


      var thumbs =
        root.querySelectorAll('[data-sb-thumb]');


      function setActiveThumb(index){

        thumbs.forEach(function(item, i){

          item.classList.toggle(
            'is-active',
            i === index
          );

        });

      }


      if(galleryTrack){

        var galleryScrollTimeout;

        galleryTrack.addEventListener(
          'scroll',
          function(){

            clearTimeout(galleryScrollTimeout);

            galleryScrollTimeout =
              setTimeout(
                function(){

                  var index =
                    Math.round(
                      galleryTrack.scrollLeft /
                      galleryTrack.clientWidth
                    );

                  setActiveThumb(index);

                },
                100
              );

          },
          { passive: true }
        );

      }


      thumbs.forEach(function(thumb, index){

        thumb.addEventListener(
          'click',
          function(){

            if(galleryTrack){

              galleryTrack.scrollTo({
                left: index * galleryTrack.clientWidth,
                behavior: 'smooth'
              });

            }


            setActiveThumb(index);

          }
        );

      });



      /* VARIANTS */

      function getSelected(){

        return (
          root.querySelector(
            '[data-sb-tier]:checked'
          )
          ||
          root.querySelector(
            '[data-sb-tier]'
          )
        );

      }


      function refresh(){

        var selected =
          getSelected();


        if(!selected){
          return;
        }


        var price =
          selected.getAttribute(
            'data-price'
          );


        var title =
          selected.getAttribute(
            'data-title'
          );


        var priceRegular =
          selected.getAttribute(
            'data-price-regular'
          );


        var priceOffer =
          selected.getAttribute(
            'data-price-offer'
          );


        root
          .querySelectorAll('[data-sb-price]')
          .forEach(function(el){

            el.textContent = price;

          });


        root
          .querySelectorAll(
            '[data-sb-sticky-variant]'
          )
          .forEach(function(el){

            el.textContent = title;

          });


        /* Keep the offer card's Regular Total / Offer Price numbers
           in sync with whichever size is actually selected — sourced
           entirely from the real Shopify variant price and the real
           Shopify discount amount already carried on the radio
           (data-price-regular / data-price-offer), never recomputed
           or hardcoded in JS. */

        if(priceRegular){

          root
            .querySelectorAll('[data-sb-gift-regular]')
            .forEach(function(el){

              el.textContent = priceRegular;

            });

        }


        if(priceOffer){

          root
            .querySelectorAll('[data-sb-gift-offer-price]')
            .forEach(function(el){

              el.textContent = priceOffer;

            });

        }


        root
          .querySelectorAll('[data-sb-gift-copy-for]')
          .forEach(function(el){

            el.hidden =
              el.getAttribute('data-sb-gift-copy-for') !== title;

          });


        /* The offer only applies to 1 Liter / 5 Liter — hide the whole
           card (not just disable it) whenever a non-qualifying size
           is selected, uncheck it if it was already checked, and
           restore it when the customer switches back to a size the
           offer does apply to. */

        var giftToggle =
          root.querySelector('[data-sb-gift-toggle]');

        var offerCard =
          root.querySelector('[data-sb-offer]');

        if(giftToggle){

          var eligible =
            selected.getAttribute('data-sb-gift-eligible') !== 'false';

          if(eligible){
            giftToggle.disabled = false;
          } else {
            giftToggle.checked = false;
            giftToggle.disabled = true;
          }

          if(offerCard){
            offerCard.hidden = !eligible;
          }

        }


        /* Switch the gallery to whichever real Shopify image is
           assigned to the selected variant (Admin > Variant >
           Image), if one is assigned. Reuses the same scroll +
           active-thumb mechanism as the manual gallery controls.
           Falls back to doing nothing when a variant has no
           dedicated image, so products without per-variant images
           are unaffected. */

        var variantImageId =
          selected.getAttribute('data-sb-variant-image-id');

        if(variantImageId && galleryTrack){

          var gallerySlides =
            root.querySelectorAll('[data-sb-gallery-slide]');

          for(var sIndex = 0; sIndex < gallerySlides.length; sIndex++){

            if(
              gallerySlides[sIndex].getAttribute('data-media-id') ===
              variantImageId
            ){

              galleryTrack.scrollTo({
                left: sIndex * galleryTrack.clientWidth,
                behavior: 'smooth'
              });

              setActiveThumb(sIndex);

              break;

            }

          }

        }


        /* Add to Cart / Buy Now / sticky bar / final CTA — disable
           and relabel "Sold Out" based on the SPECIFIC selected
           variant's own availability, not just whether the product
           has any available variant at all. Remembers each button's
           original label the first time it's overridden, so
           switching back to an in-stock size restores the real
           configured label instead of a hardcoded string. */

        var variantAvailable =
          selected.getAttribute('data-sb-available') !== 'false';

        root
          .querySelectorAll('[data-sb-add]')
          .forEach(function(addButton){

            addButton.disabled = !variantAvailable;

            var addLabel =
              addButton.querySelector('[data-sb-add-label]');

            if(!addLabel){
              return;
            }

            if(!variantAvailable){

              if(!addButton.getAttribute('data-sb-label-default')){
                addButton.setAttribute(
                  'data-sb-label-default',
                  addLabel.textContent
                );
              }

              addLabel.textContent = 'Sold Out';

            } else {

              var defaultLabel =
                addButton.getAttribute('data-sb-label-default');

              if(defaultLabel){
                addLabel.textContent = defaultLabel;
              }

            }

          });

      }


      root
        .querySelectorAll('[data-sb-tier]')
        .forEach(function(tier){

          tier.addEventListener(
            'change',
            refresh
          );

        });



      /* ADD TO CART */

      function addToCart(button){

        var selected =
          getSelected();


        if(!selected){
          return;
        }


        var id =
          parseInt(
            selected.getAttribute(
              'data-variant-id'
            ),
            10
          );


        if(!id){
          return;
        }


        /* Quantity comes from the deliberate free-gift opt-in
           checkbox, combined with however many units the CURRENTLY
           SELECTED size's own offer adds (2 for 1 Liter, 2 for 5
           Liter — see data-sb-gift-qty on each size radio). Never
           checked by default, so a plain Add to Cart always means
           quantity 1 unless the customer explicitly opted in. */

        var giftToggle =
          root.querySelector('[data-sb-gift-toggle]');

        var qty = 1;

        if(giftToggle && giftToggle.checked){

          qty =
            parseInt(
              selected.getAttribute('data-sb-gift-qty'),
              10
            ) || 1;

        }


        button.disabled = true;


        var label =
          button.querySelector(
            '[data-sb-add-label]'
          );


        var originalLabel =
          label ?
            label.textContent :
            null;


        if(label){
          label.textContent = 'Adding...';
        }


        fetch(
          '/cart/add.js',
          {
            method:'POST',

            headers:{
              'Content-Type':
                'application/json',

              'Accept':
                'application/json'
            },

            body:JSON.stringify({

              items:[
                {
                  id:id,
                  quantity:qty
                }
              ]

            })
          }
        )

        .then(function(response){

          if(!response.ok){
            throw new Error();
          }

          return response.json();

        })

        .then(function(){

          var redirectTo =
            button.getAttribute('data-sb-redirect') ||
            '/cart';

          window.location.href = redirectTo;

        })

        .catch(function(){

          button.disabled = false;


          if(label){
            label.textContent =
              originalLabel || 'Add to cart';
          }


          alert(
            'Sorry, we could not add this item to your cart. Please try again.'
          );

        });

      }


      root
        .querySelectorAll('[data-sb-add]')
        .forEach(function(button){

          button.addEventListener(
            'click',
            function(){

              addToCart(button);

            }
          );

        });



      /* STICKY */

      var sticky =
        root.querySelector(
          '[data-sb-sticky]'
        );


      var buybox =
        root.querySelector(
          '.sb-buybox'
        );


      var finalCta =
        root.querySelector(
          '.sb-final'
        );


      if(
        sticky
        &&
        buybox
        &&
        'IntersectionObserver' in window
      ){

        var buyboxVisible = true;
        var finalCtaVisible = false;


        function updateSticky(){

          sticky.hidden =
            buyboxVisible ||
            finalCtaVisible;

        }


        new IntersectionObserver(

          function(entries){

            entries.forEach(
              function(entry){

                buyboxVisible =
                  entry.isIntersecting;

                updateSticky();

              }
            );

          },

          {
            rootMargin:
              '0px 0px -65% 0px'
          }

        ).observe(buybox);


        /* Hide the sticky bar once the final CTA comes into view —
           it's redundant next to that block's own buy button, and this
           means we never need to reserve empty space at the bottom of
           the page for the fixed bar to avoid covering the footer. */
        if(finalCta){

          new IntersectionObserver(

            function(entries){

              entries.forEach(
                function(entry){

                  finalCtaVisible =
                    entry.isIntersecting;

                  updateSticky();

                }
              );

            },

            {
              rootMargin:
                '0px 0px -10% 0px'
            }

          ).observe(finalCta);

        }

      }


      refresh();


      /* COMPACT REVIEW CARD (above size picker) — real swipeable
         track (same scroll-snap technique as the product gallery
         above), auto-advances every 3s between "review" blocks,
         loops, pauses on hover/keyboard focus, and never
         auto-starts if the visitor prefers reduced motion
         (manual prev/next and touch-swipe still work either
         way). Scrolling the track by hand (touch swipe) keeps
         miniIndex in sync so auto-rotation resumes from the
         right slide. */

      var miniReview =
        root.querySelector('[data-sb-mini-review]');

      if(miniReview){

        var miniTrack =
          miniReview.querySelector('[data-sb-mini-review-track]');

        var miniSlides =
          miniReview.querySelectorAll('[data-sb-mini-review-slide]');

        var miniIndex = 0;
        var miniTimer = null;
        var miniScrollTimeout;

        var miniPrefersReducedMotion =
          window.matchMedia &&
          window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        function showMiniReview(index){

          miniIndex = index;

          miniTrack.scrollTo({
            left: index * miniTrack.clientWidth,
            behavior: 'smooth'
          });

        }

        function nextMiniReview(){
          showMiniReview((miniIndex + 1) % miniSlides.length);
        }

        function prevMiniReview(){
          showMiniReview(
            (miniIndex - 1 + miniSlides.length) % miniSlides.length
          );
        }

        function startMiniRotation(){

          if(miniSlides.length < 2 || miniPrefersReducedMotion){
            return;
          }

          stopMiniRotation();

          miniTimer = setInterval(nextMiniReview, 3000);

        }

        function stopMiniRotation(){

          if(miniTimer){
            clearInterval(miniTimer);
            miniTimer = null;
          }

        }

        if(miniTrack){

          miniTrack.addEventListener(
            'scroll',
            function(){

              clearTimeout(miniScrollTimeout);

              miniScrollTimeout = setTimeout(function(){

                miniIndex =
                  Math.round(
                    miniTrack.scrollLeft / miniTrack.clientWidth
                  );

              }, 100);

            },
            { passive: true }
          );

        }

        var miniPrevBtn =
          miniReview.querySelector('[data-sb-mini-review-prev]');

        var miniNextBtn =
          miniReview.querySelector('[data-sb-mini-review-next]');

        if(miniPrevBtn){
          miniPrevBtn.addEventListener('click', function(){
            prevMiniReview();
            startMiniRotation();
          });
        }

        if(miniNextBtn){
          miniNextBtn.addEventListener('click', function(){
            nextMiniReview();
            startMiniRotation();
          });
        }

        miniReview.addEventListener('mouseenter', stopMiniRotation);
        miniReview.addEventListener('mouseleave', startMiniRotation);
        miniReview.addEventListener('focusin', stopMiniRotation);
        miniReview.addEventListener('touchstart', stopMiniRotation, { passive: true });
        miniReview.addEventListener('touchend', startMiniRotation, { passive: true });

        miniReview.addEventListener('focusout', function(event){
          if(!miniReview.contains(event.relatedTarget)){
            startMiniRotation();
          }
        });

        startMiniRotation();

      }



      /* BUNDLE OFFER — synchronized 4-hour countdown.

         Refreshes on fixed Pakistan-time (UTC+5) boundaries
         (00:00 / 04:00 / 08:00 / 12:00 / 16:00 / 20:00), computed
         purely from the visitor's clock (Date.now()) — no
         localStorage, no per-visitor deadline, no server round
         trip. Because every visitor's browser resolves the same
         UTC instant to the same next boundary, the countdown is
         naturally identical for everyone without any syncing. */

      var offerTimer =
        root.querySelector('[data-sb-offer-timer]');

      if(offerTimer){

        var SB_PKT_OFFSET_MS = 5 * 60 * 60 * 1000;
        var SB_WINDOW_MS = 4 * 60 * 60 * 1000;

        function sbPad(value){
          return value < 10 ? '0' + value : String(value);
        }

        function renderOfferTimer(){

          var now = Date.now();
          var pktNow = now + SB_PKT_OFFSET_MS;

          var nextBoundaryPkt =
            Math.ceil(pktNow / SB_WINDOW_MS) * SB_WINDOW_MS;

          var nextBoundaryUtc =
            nextBoundaryPkt - SB_PKT_OFFSET_MS;

          var remainingMs =
            Math.max(0, nextBoundaryUtc - now);

          var totalSeconds =
            Math.floor(remainingMs / 1000);

          var hours =
            Math.floor(totalSeconds / 3600);

          var minutes =
            Math.floor((totalSeconds % 3600) / 60);

          var seconds =
            totalSeconds % 60;

          offerTimer.textContent =
            sbPad(hours) + ' : ' +
            sbPad(minutes) + ' : ' +
            sbPad(seconds);

        }

        renderOfferTimer();
        setInterval(renderOfferTimer, 1000);

      }


      /* BUNDLE OFFER — clickable "Offer ends in" shortcut.
         Adds 2 of the currently selected size, then takes the
         customer straight to the cart. The real Shopify discount
         applies automatically at checkout. */

      var offerCta =
        root.querySelector('[data-sb-offer-cta]');

      if(offerCta){

        var offerCtaBusy = false;

        offerCta.addEventListener(
          'click',
          function(){

            if(offerCtaBusy){
              return;
            }

            var selected =
              getSelected();

            if(!selected){
              return;
            }

            if(
              selected.getAttribute(
                'data-sb-gift-eligible'
              ) === 'false'
            ){
              return;
            }

            var id =
              parseInt(
                selected.getAttribute(
                  'data-variant-id'
                ),
                10
              );

            if(!id){
              return;
            }

            var ctaQty =
              parseInt(
                selected.getAttribute('data-sb-gift-qty'),
                10
              ) || 1;

            offerCtaBusy = true;
            offerCta.classList.add('is-loading');

            fetch(
              '/cart/add.js',
              {
                method:'POST',

                headers:{
                  'Content-Type':
                    'application/json',

                  'Accept':
                    'application/json'
                },

                body:JSON.stringify({

                  items:[
                    {
                      id:id,
                      quantity:ctaQty
                    }
                  ]

                })
              }
            )

            .then(function(response){

              if(!response.ok){
                throw new Error();
              }

              return response.json();

            })

            .then(function(){

              window.location.href = '/cart';

            })

            .catch(function(){

              offerCtaBusy = false;
              offerCta.classList.remove('is-loading');

              alert(
                'Sorry, we could not add this item to your cart. Please try again.'
              );

            });

          }
        );

      }

    });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solbright-product-page"] && !Shopify.designMode) return;
  try {
    

(function(){

  document
    .querySelectorAll('[data-sb-section]')
    .forEach(function(root){


      /* PRODUCT GALLERY */

      var galleryTrack =
        root.querySelector('[data-sb-gallery-track]');


      var thumbs =
        root.querySelectorAll('[data-sb-thumb]');


      function setActiveThumb(index){

        thumbs.forEach(function(item, i){

          item.classList.toggle(
            'is-active',
            i === index
          );

        });

      }


      if(galleryTrack){

        var galleryScrollTimeout;

        galleryTrack.addEventListener(
          'scroll',
          function(){

            clearTimeout(galleryScrollTimeout);

            galleryScrollTimeout =
              setTimeout(
                function(){

                  var index =
                    Math.round(
                      galleryTrack.scrollLeft /
                      galleryTrack.clientWidth
                    );

                  setActiveThumb(index);

                },
                100
              );

          },
          { passive: true }
        );

      }


      thumbs.forEach(function(thumb, index){

        thumb.addEventListener(
          'click',
          function(){

            if(galleryTrack){

              galleryTrack.scrollTo({
                left: index * galleryTrack.clientWidth,
                behavior: 'smooth'
              });

            }


            setActiveThumb(index);

          }
        );

      });



      /* VARIANTS */

      function getSelected(){

        return (
          root.querySelector(
            '[data-sb-tier]:checked'
          )
          ||
          root.querySelector(
            '[data-sb-tier]'
          )
        );

      }


      function refresh(){

        var selected =
          getSelected();


        if(!selected){
          return;
        }


        var price =
          selected.getAttribute(
            'data-price'
          );


        var title =
          selected.getAttribute(
            'data-title'
          );


        var priceRegular =
          selected.getAttribute(
            'data-price-regular'
          );


        var priceOffer =
          selected.getAttribute(
            'data-price-offer'
          );


        root
          .querySelectorAll('[data-sb-price]')
          .forEach(function(el){

            el.textContent = price;

          });


        root
          .querySelectorAll(
            '[data-sb-sticky-variant]'
          )
          .forEach(function(el){

            el.textContent = title;

          });


        /* Keep the offer card's Regular Total / Offer Price numbers
           in sync with whichever size is actually selected — sourced
           entirely from the real Shopify variant price and the real
           Shopify discount amount already carried on the radio
           (data-price-regular / data-price-offer), never recomputed
           or hardcoded in JS. */

        if(priceRegular){

          root
            .querySelectorAll('[data-sb-gift-regular]')
            .forEach(function(el){

              el.textContent = priceRegular;

            });

        }


        if(priceOffer){

          root
            .querySelectorAll('[data-sb-gift-offer-price]')
            .forEach(function(el){

              el.textContent = priceOffer;

            });

        }


        root
          .querySelectorAll('[data-sb-gift-copy-for]')
          .forEach(function(el){

            el.hidden =
              el.getAttribute('data-sb-gift-copy-for') !== title;

          });


        /* The offer only applies to 1 Liter / 5 Liter — hide the whole
           card (not just disable it) whenever a non-qualifying size
           is selected, uncheck it if it was already checked, and
           restore it when the customer switches back to a size the
           offer does apply to. */

        var giftToggle =
          root.querySelector('[data-sb-gift-toggle]');

        var offerCard =
          root.querySelector('[data-sb-offer]');

        if(giftToggle){

          var eligible =
            selected.getAttribute('data-sb-gift-eligible') !== 'false';

          if(eligible){
            giftToggle.disabled = false;
          } else {
            giftToggle.checked = false;
            giftToggle.disabled = true;
          }

          if(offerCard){
            offerCard.hidden = !eligible;
          }

        }


        /* Switch the gallery to whichever real Shopify image is
           assigned to the selected variant (Admin > Variant >
           Image), if one is assigned. Reuses the same scroll +
           active-thumb mechanism as the manual gallery controls.
           Falls back to doing nothing when a variant has no
           dedicated image, so products without per-variant images
           are unaffected. */

        var variantImageId =
          selected.getAttribute('data-sb-variant-image-id');

        if(variantImageId && galleryTrack){

          var gallerySlides =
            root.querySelectorAll('[data-sb-gallery-slide]');

          for(var sIndex = 0; sIndex < gallerySlides.length; sIndex++){

            if(
              gallerySlides[sIndex].getAttribute('data-media-id') ===
              variantImageId
            ){

              galleryTrack.scrollTo({
                left: sIndex * galleryTrack.clientWidth,
                behavior: 'smooth'
              });

              setActiveThumb(sIndex);

              break;

            }

          }

        }


        /* Add to Cart / Buy Now / sticky bar / final CTA — disable
           and relabel "Sold Out" based on the SPECIFIC selected
           variant's own availability, not just whether the product
           has any available variant at all. Remembers each button's
           original label the first time it's overridden, so
           switching back to an in-stock size restores the real
           configured label instead of a hardcoded string. */

        var variantAvailable =
          selected.getAttribute('data-sb-available') !== 'false';

        root
          .querySelectorAll('[data-sb-add]')
          .forEach(function(addButton){

            addButton.disabled = !variantAvailable;

            var addLabel =
              addButton.querySelector('[data-sb-add-label]');

            if(!addLabel){
              return;
            }

            if(!variantAvailable){

              if(!addButton.getAttribute('data-sb-label-default')){
                addButton.setAttribute(
                  'data-sb-label-default',
                  addLabel.textContent
                );
              }

              addLabel.textContent = 'Sold Out';

            } else {

              var defaultLabel =
                addButton.getAttribute('data-sb-label-default');

              if(defaultLabel){
                addLabel.textContent = defaultLabel;
              }

            }

          });

      }


      root
        .querySelectorAll('[data-sb-tier]')
        .forEach(function(tier){

          tier.addEventListener(
            'change',
            refresh
          );

        });



      /* ADD TO CART */

      function addToCart(button){

        var selected =
          getSelected();


        if(!selected){
          return;
        }


        var id =
          parseInt(
            selected.getAttribute(
              'data-variant-id'
            ),
            10
          );


        if(!id){
          return;
        }


        /* Quantity comes from the deliberate free-gift opt-in
           checkbox, combined with however many units the CURRENTLY
           SELECTED size's own offer adds (2 for 1 Liter, 2 for 5
           Liter — see data-sb-gift-qty on each size radio). Never
           checked by default, so a plain Add to Cart always means
           quantity 1 unless the customer explicitly opted in. */

        var giftToggle =
          root.querySelector('[data-sb-gift-toggle]');

        var qty = 1;

        if(giftToggle && giftToggle.checked){

          qty =
            parseInt(
              selected.getAttribute('data-sb-gift-qty'),
              10
            ) || 1;

        }


        button.disabled = true;


        var label =
          button.querySelector(
            '[data-sb-add-label]'
          );


        var originalLabel =
          label ?
            label.textContent :
            null;


        if(label){
          label.textContent = 'Adding...';
        }


        fetch(
          '/cart/add.js',
          {
            method:'POST',

            headers:{
              'Content-Type':
                'application/json',

              'Accept':
                'application/json'
            },

            body:JSON.stringify({

              items:[
                {
                  id:id,
                  quantity:qty
                }
              ]

            })
          }
        )

        .then(function(response){

          if(!response.ok){
            throw new Error();
          }

          return response.json();

        })

        .then(function(){

          var redirectTo =
            button.getAttribute('data-sb-redirect') ||
            '/cart';

          window.location.href = redirectTo;

        })

        .catch(function(){

          button.disabled = false;


          if(label){
            label.textContent =
              originalLabel || 'Add to cart';
          }


          alert(
            'Sorry, we could not add this item to your cart. Please try again.'
          );

        });

      }


      root
        .querySelectorAll('[data-sb-add]')
        .forEach(function(button){

          button.addEventListener(
            'click',
            function(){

              addToCart(button);

            }
          );

        });



      /* STICKY */

      var sticky =
        root.querySelector(
          '[data-sb-sticky]'
        );


      var buybox =
        root.querySelector(
          '.sb-buybox'
        );


      var finalCta =
        root.querySelector(
          '.sb-final'
        );


      if(
        sticky
        &&
        buybox
        &&
        'IntersectionObserver' in window
      ){

        var buyboxVisible = true;
        var finalCtaVisible = false;


        function updateSticky(){

          sticky.hidden =
            buyboxVisible ||
            finalCtaVisible;

        }


        new IntersectionObserver(

          function(entries){

            entries.forEach(
              function(entry){

                buyboxVisible =
                  entry.isIntersecting;

                updateSticky();

              }
            );

          },

          {
            rootMargin:
              '0px 0px -65% 0px'
          }

        ).observe(buybox);


        /* Hide the sticky bar once the final CTA comes into view —
           it's redundant next to that block's own buy button, and this
           means we never need to reserve empty space at the bottom of
           the page for the fixed bar to avoid covering the footer. */
        if(finalCta){

          new IntersectionObserver(

            function(entries){

              entries.forEach(
                function(entry){

                  finalCtaVisible =
                    entry.isIntersecting;

                  updateSticky();

                }
              );

            },

            {
              rootMargin:
                '0px 0px -10% 0px'
            }

          ).observe(finalCta);

        }

      }


      refresh();


      /* BUNDLE OFFER — synchronized 4-hour countdown.

         Refreshes on fixed Pakistan-time (UTC+5) boundaries
         (00:00 / 04:00 / 08:00 / 12:00 / 16:00 / 20:00), computed
         purely from the visitor's clock (Date.now()) — no
         localStorage, no per-visitor deadline, no server round
         trip. Because every visitor's browser resolves the same
         UTC instant to the same next boundary, the countdown is
         naturally identical for everyone without any syncing. */

      var offerTimer =
        root.querySelector('[data-sb-offer-timer]');

      if(offerTimer){

        var SB_PKT_OFFSET_MS = 5 * 60 * 60 * 1000;
        var SB_WINDOW_MS = 4 * 60 * 60 * 1000;

        function sbPad(value){
          return value < 10 ? '0' + value : String(value);
        }

        function renderOfferTimer(){

          var now = Date.now();
          var pktNow = now + SB_PKT_OFFSET_MS;

          var nextBoundaryPkt =
            Math.ceil(pktNow / SB_WINDOW_MS) * SB_WINDOW_MS;

          var nextBoundaryUtc =
            nextBoundaryPkt - SB_PKT_OFFSET_MS;

          var remainingMs =
            Math.max(0, nextBoundaryUtc - now);

          var totalSeconds =
            Math.floor(remainingMs / 1000);

          var hours =
            Math.floor(totalSeconds / 3600);

          var minutes =
            Math.floor((totalSeconds % 3600) / 60);

          var seconds =
            totalSeconds % 60;

          offerTimer.textContent =
            sbPad(hours) + ' : ' +
            sbPad(minutes) + ' : ' +
            sbPad(seconds);

        }

        renderOfferTimer();
        setInterval(renderOfferTimer, 1000);

      }


      /* BUNDLE OFFER — clickable "Offer ends in" shortcut.
         Adds 2 of the currently selected size, then takes the
         customer straight to the cart. The real Shopify discount
         applies automatically at checkout. */

      var offerCta =
        root.querySelector('[data-sb-offer-cta]');

      if(offerCta){

        var offerCtaBusy = false;

        offerCta.addEventListener(
          'click',
          function(){

            if(offerCtaBusy){
              return;
            }

            var selected =
              getSelected();

            if(!selected){
              return;
            }

            if(
              selected.getAttribute(
                'data-sb-gift-eligible'
              ) === 'false'
            ){
              return;
            }

            var id =
              parseInt(
                selected.getAttribute(
                  'data-variant-id'
                ),
                10
              );

            if(!id){
              return;
            }

            var ctaQty =
              parseInt(
                selected.getAttribute('data-sb-gift-qty'),
                10
              ) || 1;

            offerCtaBusy = true;
            offerCta.classList.add('is-loading');

            fetch(
              '/cart/add.js',
              {
                method:'POST',

                headers:{
                  'Content-Type':
                    'application/json',

                  'Accept':
                    'application/json'
                },

                body:JSON.stringify({

                  items:[
                    {
                      id:id,
                      quantity:ctaQty
                    }
                  ]

                })
              }
            )

            .then(function(response){

              if(!response.ok){
                throw new Error();
              }

              return response.json();

            })

            .then(function(){

              window.location.href = '/cart';

            })

            .catch(function(){

              offerCtaBusy = false;
              offerCta.classList.remove('is-loading');

              alert(
                'Sorry, we could not add this item to your cart. Please try again.'
              );

            });

          }
        );

      }

    });

})();


  } catch(e) { console.error(e); }
})();
})();
